export const TRANSLATIONS = {
  en: {
    nav: {
      home: "Home", about: "About Us", products: "Products",
      catalogue: "Catalogue",
      applications: "Applications", why: "Why RK Jain",
      enquiry: "Enquiry", contact: "Contact Us",
    },
    common: {
      enquireNow: "Enquire Now", exploreProducts: "Explore Products",
      viewAllProducts: "View All Products", viewDetails: "View Details",
      enquire: "Enquire", contactUs: "Contact Us", requestQuote: "Request a Quote",
      allProducts: "All Products", relatedProducts: "Related Products",
      keyFeatures: "Key Features",
      applications: "Applications", productOverview: "Product Overview",
      exploreSolutions: "Explore Solutions",
      specNote: "Detailed technical specifications for this product will be published soon. For exact models, sizes and availability, please enquire.",
      interestedIn: "Interested in {name}?",
    },
    hero: {
      overline: "SINCE 1984 · TRUSTED ACROSS INDIA",
      line1: "Powering Growth.",
      line2: "Delivering Reliability.",
      subtitle: "Serving India since 1984, RK Jain delivers reliable pumping and agricultural solutions trusted by customers nationwide.",
    },
    trust: {
      established: "Established in 1984",
      customers: "50,000+ Happy Customers",
      iso: "ISO Certified Company",
      panIndia: "Pan India Supply",
    },
    why: {
      eyebrow: "Why RK Jain",
      title: "The engineering partner India trusts.",
      desc: "Four decades of relentless quality, honest service and dependable performance — the reasons customers return to RK Jain, generation after generation.",
      items: {
        established: { title: "Established in 1984", text: "Serving India with dedication for four decades." },
        customers: { title: "50,000+ Happy Customers", text: "A growing family of farmers, homes and businesses." },
        iso: { title: "ISO Certified Company", text: "Stringent quality standards on every product." },
        panindia: { title: "Pan India Supply", text: "Dependable delivery to every corner of India." },
        quality: { title: "Reliable Quality", text: "Built to perform, season after season." },
        performance: { title: "Trusted Performance", text: "Efficiency you can measure and count on." },
      },
      pageTitle: "The reasons customers stay for life.",
      pageSubtitle: "Four decades of quality, service and dependable performance — here's what sets RK Jain apart.",
      getInTouch: "Get in Touch",
      getInTouchTitle: "Experience the RK Jain difference.",
    },
    stats: {
      years: "Years of Experience", customers: "Happy Customers",
      supply: "Supply Across India", iso: "Certified Company",
      support: "Customer Support", yearsShort: "Years", customersShort: "Customers",
      supportShort: "Support", certified: "Certified", supplyNetwork: "Supply Network",
      panIndiaValue: "Pan India", isoValue: "ISO",
    },
    productsSection: {
      eyebrow: "Our Products",
      title: "Solutions built for every need.",
      desc: "From deep-borewell pumps to complete irrigation systems, pipes, cables and farm machinery — engineered to deliver.",
    },
    categories: {
      All: "All", Pumps: "Pumps", Pipes: "Pipes", Cables: "Cables",
      "Atta Chakki": "Atta Chakki", "Chaff Cutter": "Chaff Cutter",
      "Drip Irrigation": "Drip Irrigation", "Spray Pumps": "Spray Pumps",
      Vacuum: "Vacuum", Generator: "Generator", STP: "STP",
      Irrigation: "Irrigation", Machinery: "Machinery",
    },
    apps: {
      eyebrow: "Applications",
      titleHome: "Powering every industry we touch.",
      titlePage: "Solutions for every field of work.",
      subtitlePage: "Wherever water needs to move and grow, RK Jain delivers dependable performance — across agriculture, industry, homes and infrastructure.",
      names: {
        Agriculture: "Agriculture", Residential: "Residential", Commercial: "Commercial",
        Industrial: "Industrial", Construction: "Construction",
        "Water Supply": "Water Supply", Irrigation: "Irrigation",
      },
      desc: {
        Agriculture: "Reliable water and power for farms of every size — from smallholdings to large estates.",
        Residential: "Consistent water supply and pressure for homes, apartments and housing societies.",
        Commercial: "Dependable solutions for shops, offices, showrooms and commercial complexes.",
        Industrial: "Heavy-duty pumping and dewatering built for continuous industrial demand.",
        Construction: "Rugged dewatering and water-handling equipment for tough construction sites.",
        "Water Supply": "Infrastructure-grade systems for municipal and community water distribution.",
        Irrigation: "Precision sprinkler and drip systems that conserve water and boost yield.",
      },
    },
    iso: {
      eyebrow: "Quality Assurance",
      title: "ISO Certified Manufacturing Excellence",
      desc: "RK Jain follows stringent quality standards to manufacture dependable products trusted across India. Every unit is tested to deliver consistent, long-lasting performance.",
      chips: ["Quality Tested", "Precision Built", "Durability Assured"],
      certified: "Certified",
    },
    manifesto: {
      eyebrow: "Our Philosophy",
      title: "Three principles. Since 1984.",
      items: [
        { title: "Rooted in Trust", text: "Since 1984, our name has stood for reliability — earned one satisfied customer at a time." },
        { title: "Engineered to Endure", text: "Every pump, pipe and machine is built to survive India's toughest conditions and keep on working." },
        { title: "Growing with India", text: "From remote farms to modern cities, we deliver the water and power solutions that fuel progress." },
      ],
    },
    testimonials: {
      eyebrow: "Testimonials",
      title: "Trusted, in their own words.",
      items: [
        { name: "Rajesh Patil", role: "Farmer, Ahilyanagar", text: "RK Jain pumps have powered my fields for over a decade without a single failure. Complete peace of mind." },
        { name: "Sunita Deshmukh", role: "Contractor, Pune", text: "Reliable products and honest service. Their team understands exactly what we need on site." },
        { name: "Mohan Agarwal", role: "Distributor, Nashik", text: "A brand my customers ask for by name. Quality that speaks for itself, year after year." },
      ],
    },
    founder: {
      eyebrow: "Leadership",
      l1: "Vision.", l2: "Trust.", l3: "Commitment.",
      intro: "Since 1984, Mr. Ratnesh Kothari has served customers with one simple belief — and built RK Jain into a name families across India trust for generations.",
      philosophy: "Customer First, Always.",
      pillars: [
        { title: "Customer First", text: "Every solution. Every time." },
        { title: "Quality Driven", text: "Built to perform. Built to last." },
        { title: "Trust Over Generations", text: "Relationships that grow stronger." },
      ],
      quote: "Our goal has always been simple — put the customer first and deliver the best.",
      name: "Mr. Ratnesh Kothari",
      role: "Founder",
    },
    cta: {
      title: "Ready to power your growth?",
      desc: "Talk to our team today. Get the right solution for your farm, home or business.",
      whatsapp: "Enquire on WhatsApp", contact: "Contact Us",
    },
    footer: {
      desc: "Serving India since 1984, RK Jain delivers reliable pumping and agricultural solutions trusted by customers nationwide.",
      quickLinks: "Quick Links", products: "Products", contact: "Contact",
      privacy: "Privacy Policy", rights: "© {year} RK Jain. All rights reserved.",
      crafted: "Crafted with precision.",
    },
    about: {
      eyebrow: "About Us",
      title: "Serving India since 1984.",
      subtitle: "RK Jain is a trusted Indian manufacturer and supplier of pumping and agricultural solutions, serving customers across the nation.",
      overviewEyebrow: "Company Overview",
      overviewTitle: "Rooted in reliability. Growing with India.",
      overviewP1: "Since 1984, RK Jain has delivered dependable pumping and agricultural solutions to farmers, homes and businesses across India. Our reputation is built on consistent quality, honest service and products engineered to endure.",
      overviewP2: "[Editable placeholder: Add your detailed company history, milestones and leadership story here. This section is ready to be updated with your original content whenever available.]",
      missionTitle: "Our Mission",
      missionText: "To empower India's farms, homes and industries with reliable, affordable and long-lasting pumping and agricultural solutions — backed by service that earns lifelong trust.",
      visionTitle: "Our Vision",
      visionText: "To be India's most trusted name in pumping and agricultural solutions — recognised for quality, innovation and unwavering commitment to every customer we serve.",
      valuesEyebrow: "Core Values",
      valuesTitle: "What we stand for.",
      values: [
        { title: "Quality First", text: "We never compromise on the materials and engineering behind our products." },
        { title: "Customer Trust", text: "Long-term relationships built on honesty, service and reliability." },
        { title: "Integrity", text: "Doing right by our customers, partners and community — always." },
        { title: "Dependability", text: "Products and delivery you can count on, right across India." },
      ],
    },
    productsPage: {
      eyebrow: "Our Products",
      title: "A complete range, engineered to deliver.",
      subtitle: "Pumps, irrigation, pipes, cables and farm machinery — dependable solutions for every requirement across India.",
    },
    catalogue: {
      eyebrow: "Product Catalogue",
      title: "Every product, one catalogue.",
      subtitle: "Flip through, zoom, view full-screen or download the complete RK Jain product catalogue.",
      heading: "Product Catalogue",
      description:
        "Browse our complete range of pumps, pipes, agricultural equipment, electrical products, and accessories. View the catalogue online or download it for future reference.",
      downloadBtn: "Download Catalogue",
      fullScreen: "Full Screen",
      mobileNote:
        "On mobile, the embedded viewer may look small — tap 'Download Catalogue' for the best reading experience.",
    },
    enquiryPage: {
      eyebrow: "Enquiry",
      title: "Let's find the right solution for you.",
      subtitle: "Share your requirement and our team will get back to you shortly. Prefer to talk now? Reach us instantly on WhatsApp.",
      sideEyebrow: "Get in Touch",
      sideTitle: "Tell us what you need.",
      sideText: "Whether it's a single pump or a complete irrigation system, our team is ready to help you choose the right solution for your farm, home or business.",
      chatWhatsapp: "Chat on WhatsApp", fastest: "Fastest response",
      callUs: "Call Us", workingHours: "Working Hours",
      hoursValue: "Mon – Sat · 9:00 AM to 8:00 PM",
    },
    contact: {
      eyebrow: "Contact Us",
      title: "We're here to help.",
      subtitle: "Reach out for products, quotes or support. Our team is always ready to assist you.",
      phone: "Phone", email: "Email", address: "Address",
      messageWhatsapp: "Message on WhatsApp",
      followUs: "Follow Us",
    },
    form: {
      name: "Name", company: "Company", phone: "Phone Number", email: "Email",
      city: "City", state: "State", product: "Product Interested In",
      requirement: "Requirement", message: "Message",
      selectState: "Select State", selectProduct: "Select Product",
      submit: "Submit Enquiry", submitting: "Submitting...",
      namePh: "Your full name", companyPh: "Company / Firm", phonePh: "+91",
      emailPh: "you@example.com", cityPh: "City",
      reqPh: "e.g. Quantity, HP, size, timeline", msgPh: "Tell us more about your requirement...",
      validation: "Please enter your name and phone number.",
      successToast: "Enquiry submitted successfully!",
      errorToast: "Something went wrong. Please try again or use WhatsApp.",
      thankYou: "Thank You!",
      thankYouText: "Our team will contact you shortly. For an instant response, continue the conversation with us on WhatsApp.",
      continueWhatsapp: "Continue on WhatsApp",
      newEnquiry: "Submit another enquiry",
    },
    marquee: ["Pumps", "Irrigation", "Pipes", "Cables", "Farm Machinery", "Water Systems"],
    productExtra: {
      specifications: "Technical Specifications",
      availableSizes: "Available Sizes",
      advantages: "Advantages",
      model: "Model",
      downloadBrochure: "Download Brochure",
      productBrochure: "Product Brochure",
      brochureCaption: "The full original product brochure with all specifications and variants.",
    },
  },

  mr: {
    nav: {
      home: "मुख्यपृष्ठ", about: "आमच्याविषयी", products: "उत्पादने",
      catalogue: "माहितीपत्रक",
      applications: "उपयोग", why: "आरके जैन का?",
      enquiry: "चौकशी", contact: "संपर्क",
    },
    common: {
      enquireNow: "चौकशी करा", exploreProducts: "उत्पादने पाहा",
      viewAllProducts: "सर्व उत्पादने पाहा", viewDetails: "अधिक माहिती",
      enquire: "चौकशी", contactUs: "संपर्क करा", requestQuote: "दर विचारा",
      allProducts: "सर्व उत्पादने", relatedProducts: "संबंधित उत्पादने",
      keyFeatures: "प्रमुख वैशिष्ट्ये",
      applications: "उपयोग", productOverview: "उत्पादनाची माहिती",
      exploreSolutions: "उपाय पाहा",
      specNote: "या उत्पादनाची सविस्तर तांत्रिक माहिती लवकरच उपलब्ध होईल. नेमके मॉडेल, आकार व उपलब्धतेसाठी कृपया चौकशी करा.",
      interestedIn: "{name} विषयी माहिती हवी आहे?",
    },
    hero: {
      overline: "१९८४ पासून · संपूर्ण भारतात विश्वासार्ह",
      line1: "प्रगतीला बळ.",
      line2: "विश्वासाची हमी.",
      subtitle: "१९८४ पासून आरके जैन संपूर्ण भारतातील ग्राहकांना विश्वासार्ह पंपिंग व कृषी उपाय पुरवत आहे.",
    },
    trust: {
      established: "१९८४ मध्ये स्थापित",
      customers: "५०,०००+ समाधानी ग्राहक",
      iso: "आयएसओ प्रमाणित कंपनी",
      panIndia: "संपूर्ण भारतात पुरवठा",
    },
    why: {
      eyebrow: "आरके जैन का?",
      title: "भारताचा विश्वासू अभियांत्रिकी भागीदार.",
      desc: "चार दशकांची अखंड गुणवत्ता, प्रामाणिक सेवा आणि विश्वासार्ह कामगिरी — म्हणूनच पिढ्यानपिढ्या ग्राहक आरके जैनकडे परत येतात.",
      items: {
        established: { title: "१९८४ मध्ये स्थापित", text: "चार दशके निष्ठेने भारताची सेवा." },
        customers: { title: "५०,०००+ समाधानी ग्राहक", text: "शेतकरी, घरे व व्यवसायांचे वाढते कुटुंब." },
        iso: { title: "आयएसओ प्रमाणित कंपनी", text: "प्रत्येक उत्पादनावर कठोर गुणवत्ता मानके." },
        panindia: { title: "संपूर्ण भारतात पुरवठा", text: "भारताच्या कानाकोपऱ्यात विश्वासार्ह पुरवठा." },
        quality: { title: "विश्वासार्ह गुणवत्ता", text: "प्रत्येक हंगामात उत्तम कामगिरी." },
        performance: { title: "विश्वासार्ह कामगिरी", text: "मोजता येईल अशी खात्रीशीर कार्यक्षमता." },
      },
      pageTitle: "ग्राहक आयुष्यभर सोबत राहण्याची कारणे.",
      pageSubtitle: "चार दशकांची गुणवत्ता, सेवा आणि विश्वासार्ह कामगिरी — हेच आरके जैनला वेगळे ठरवते.",
      getInTouch: "संपर्कात रहा",
      getInTouchTitle: "आरके जैनचा फरक अनुभवा.",
    },
    stats: {
      years: "वर्षांचा अनुभव", customers: "समाधानी ग्राहक",
      supply: "संपूर्ण भारतात पुरवठा", iso: "प्रमाणित कंपनी",
      support: "ग्राहक सहाय्य", yearsShort: "वर्षे", customersShort: "ग्राहक",
      supportShort: "सहाय्य", certified: "प्रमाणित", supplyNetwork: "पुरवठा जाळे",
      panIndiaValue: "संपूर्ण भारत", isoValue: "आयएसओ",
    },
    productsSection: {
      eyebrow: "आमची उत्पादने",
      title: "प्रत्येक गरजेसाठी उपाय.",
      desc: "खोल बोअरवेल पंपांपासून संपूर्ण सिंचन प्रणाली, पाईप, केबल व कृषी यंत्रसामग्रीपर्यंत — दर्जेदार कामगिरीसाठी बनवलेले.",
    },
    categories: {
      All: "सर्व", Pumps: "पंप", Pipes: "पाईप", Cables: "केबल",
      "Atta Chakki": "आटा चक्की", "Chaff Cutter": "चारा कटर",
      "Drip Irrigation": "ठिबक सिंचन", "Spray Pumps": "फवारणी पंप",
      Vacuum: "व्हॅक्युम", Generator: "जनरेटर", STP: "STP",
      Irrigation: "सिंचन", Machinery: "यंत्रसामग्री",
    },
    apps: {
      eyebrow: "उपयोग",
      titleHome: "प्रत्येक क्षेत्राला बळ देणारे उपाय.",
      titlePage: "प्रत्येक कामाच्या क्षेत्रासाठी उपाय.",
      subtitlePage: "जिथे पाणी पोहोचवायचे व पिकवायचे असते, तिथे आरके जैन विश्वासार्ह कामगिरी देते — शेती, उद्योग, घरे व पायाभूत सुविधांमध्ये.",
      names: {
        Agriculture: "शेती", Residential: "निवासी", Commercial: "व्यावसायिक",
        Industrial: "औद्योगिक", Construction: "बांधकाम",
        "Water Supply": "पाणीपुरवठा", Irrigation: "सिंचन",
      },
      desc: {
        Agriculture: "लहान शेतांपासून मोठ्या मळ्यांपर्यंत — प्रत्येक शेतासाठी विश्वासार्ह पाणी व शक्ती.",
        Residential: "घरे, अपार्टमेंट व गृहनिर्माण संस्थांसाठी सातत्यपूर्ण पाणीपुरवठा व दाब.",
        Commercial: "दुकाने, कार्यालये, शोरूम व व्यावसायिक संकुलांसाठी विश्वासार्ह उपाय.",
        Industrial: "सततच्या औद्योगिक गरजांसाठी मजबूत पंपिंग व पाणी उपसा.",
        Construction: "कठीण बांधकाम स्थळांसाठी मजबूत पाणी उपसा उपकरणे.",
        "Water Supply": "नगरपालिका व सामुदायिक पाणी वितरणासाठी पायाभूत दर्जाची प्रणाली.",
        Irrigation: "पाणी वाचवून उत्पादन वाढवणारी अचूक स्प्रिंकलर व ड्रिप प्रणाली.",
      },
    },
    iso: {
      eyebrow: "गुणवत्तेची हमी",
      title: "आयएसओ प्रमाणित उत्पादन उत्कृष्टता",
      desc: "आरके जैन भारतभर विश्वासार्ह उत्पादने घडवण्यासाठी कठोर गुणवत्ता मानके पाळते. प्रत्येक युनिट सातत्यपूर्ण व दीर्घकाळ टिकणाऱ्या कामगिरीसाठी तपासले जाते.",
      chips: ["गुणवत्ता तपासलेले", "अचूक बनावट", "टिकाऊपणाची हमी"],
      certified: "प्रमाणित",
    },
    manifesto: {
      eyebrow: "आमचे तत्त्वज्ञान",
      title: "तीन तत्त्वे. १९८४ पासून.",
      items: [
        { title: "विश्वासावर आधारित", text: "१९८४ पासून आमचे नाव विश्वासार्हतेचे प्रतीक आहे — एकेक समाधानी ग्राहकाच्या माध्यमातून कमावलेले." },
        { title: "टिकाऊपणासाठी बनवलेले", text: "प्रत्येक पंप, पाईप व यंत्र भारतातील कठीण परिस्थितीतही अखंड चालण्यासाठी घडवलेले." },
        { title: "भारतासोबत वाढणारे", text: "दूरच्या शेतांपासून आधुनिक शहरांपर्यंत, प्रगतीला बळ देणारे पाणी व शक्ती उपाय आम्ही पुरवतो." },
      ],
    },
    testimonials: {
      eyebrow: "ग्राहकांचे अनुभव",
      title: "ग्राहकांच्याच शब्दांत, विश्वास.",
      items: [
        { name: "राजेश पाटील", role: "शेतकरी, अहिल्यानगर", text: "आरके जैनचे पंप दहा वर्षांहून अधिक काळ माझ्या शेताला बळ देत आहेत — एकही बिघाड न होता. पूर्ण निश्चिंतता." },
        { name: "सुनिता देशमुख", role: "कंत्राटदार, पुणे", text: "विश्वासार्ह उत्पादने आणि प्रामाणिक सेवा. साइटवर नेमके काय हवे हे त्यांची टीम अचूक समजते." },
        { name: "मोहन अगरवाल", role: "वितरक, नाशिक", text: "माझे ग्राहक नावानेच मागतात असा ब्रँड. वर्षानुवर्षे गुणवत्ता स्वतःच बोलते." },
      ],
    },
    founder: {
      eyebrow: "नेतृत्व",
      l1: "दूरदृष्टी.", l2: "विश्वास.", l3: "बांधिलकी.",
      intro: "१९८४ पासून श्री. रत्नेश कोठारी एका साध्या विश्वासाने ग्राहकांची सेवा करत आहेत — आणि आरके जैनला पिढ्यानपिढ्या भारतभर विश्वासाचे नाव बनवले आहे.",
      philosophy: "ग्राहक प्रथम, नेहमीच.",
      pillars: [
        { title: "ग्राहक प्रथम", text: "प्रत्येक उपाय. प्रत्येक वेळी." },
        { title: "गुणवत्तेला प्राधान्य", text: "उत्तम कामगिरीसाठी, दीर्घकाळ टिकण्यासाठी." },
        { title: "पिढ्यानपिढ्या विश्वास", text: "अधिकाधिक दृढ होणारे नाते." },
      ],
      quote: "आमचे ध्येय नेहमीच साधे राहिले आहे — ग्राहकाला प्रथम स्थान द्या आणि सर्वोत्तम द्या.",
      name: "श्री. रत्नेश कोठारी",
      role: "संस्थापक",
    },
    cta: {
      title: "तुमच्या प्रगतीला बळ द्यायला तयार आहात?",
      desc: "आजच आमच्या टीमशी बोला. तुमच्या शेत, घर किंवा व्यवसायासाठी योग्य उपाय मिळवा.",
      whatsapp: "व्हॉट्सअ‍ॅपवर चौकशी करा", contact: "संपर्क करा",
    },
    footer: {
      desc: "१९८४ पासून आरके जैन संपूर्ण भारतातील ग्राहकांना विश्वासार्ह पंपिंग व कृषी उपाय पुरवत आहे.",
      quickLinks: "द्रुत दुवे", products: "उत्पादने", contact: "संपर्क",
      privacy: "गोपनीयता धोरण", rights: "© {year} आरके जैन. सर्व हक्क राखीव.",
      crafted: "अचूकतेने साकारलेले.",
    },
    about: {
      eyebrow: "आमच्याविषयी",
      title: "१९८४ पासून भारताची सेवा.",
      subtitle: "आरके जैन ही पंपिंग व कृषी उपायांची विश्वासार्ह भारतीय उत्पादक व पुरवठादार कंपनी असून संपूर्ण देशभर ग्राहकांची सेवा करते.",
      overviewEyebrow: "कंपनी परिचय",
      overviewTitle: "विश्वासावर आधारित. भारतासोबत वाढणारे.",
      overviewP1: "१९८४ पासून आरके जैन संपूर्ण भारतातील शेतकरी, घरे व व्यवसायांना विश्वासार्ह पंपिंग व कृषी उपाय पुरवत आहे. सातत्यपूर्ण गुणवत्ता, प्रामाणिक सेवा व टिकाऊ उत्पादनांवर आमची प्रतिष्ठा उभी आहे.",
      overviewP2: "[संपादनयोग्य: येथे तुमचा सविस्तर कंपनी इतिहास, टप्पे व नेतृत्वाची कथा जोडा. उपलब्ध होताच हा भाग तुमच्या मूळ मजकुराने अद्ययावत करता येईल.]",
      missionTitle: "आमचे ध्येय",
      missionText: "भारतातील शेती, घरे व उद्योगांना विश्वासार्ह, परवडणारे व दीर्घकाळ टिकणारे पंपिंग व कृषी उपाय देऊन सक्षम करणे — आयुष्यभराचा विश्वास कमावणाऱ्या सेवेसह.",
      visionTitle: "आमची दूरदृष्टी",
      visionText: "पंपिंग व कृषी उपायांमध्ये भारताचे सर्वात विश्वासार्ह नाव होणे — गुणवत्ता, नाविन्य व प्रत्येक ग्राहकाप्रती अढळ बांधिलकीसाठी ओळखले जाणारे.",
      valuesEyebrow: "मूलभूत मूल्ये",
      valuesTitle: "आम्ही कशासाठी उभे आहोत.",
      values: [
        { title: "गुणवत्ता प्रथम", text: "आमच्या उत्पादनांमागील साहित्य व अभियांत्रिकीशी आम्ही कधीही तडजोड करत नाही." },
        { title: "ग्राहकांचा विश्वास", text: "प्रामाणिकपणा, सेवा व विश्वासार्हतेवर आधारित दीर्घकालीन नाते." },
        { title: "सचोटी", text: "आमचे ग्राहक, भागीदार व समाजाशी नेहमीच योग्य वागणे." },
        { title: "विश्वासार्हता", text: "संपूर्ण भारतभर भरवसा ठेवता येईल अशी उत्पादने व पुरवठा." },
      ],
    },
    productsPage: {
      eyebrow: "आमची उत्पादने",
      title: "संपूर्ण श्रेणी, दर्जेदार कामगिरीसाठी.",
      subtitle: "पंप, सिंचन, पाईप, केबल व कृषी यंत्रसामग्री — भारतभर प्रत्येक गरजेसाठी विश्वासार्ह उपाय.",
    },
    catalogue: {
      eyebrow: "उत्पादन माहितीपत्रक",
      title: "प्रत्येक उत्पादन, एका माहितीपत्रकात.",
      subtitle: "पाहा, झूम करा, पूर्ण स्क्रीनवर उघडा किंवा संपूर्ण आरके जैन उत्पादन माहितीपत्रक डाउनलोड करा.",
      heading: "उत्पादन माहितीपत्रक",
      description:
        "आमच्या पंप, पाईप, कृषी उपकरणे, इलेक्ट्रिकल उत्पादने व अ‍ॅक्सेसरीजची संपूर्ण श्रेणी पहा. ऑनलाइन पहा किंवा भविष्यातील संदर्भासाठी डाउनलोड करा.",
      downloadBtn: "माहितीपत्रक डाउनलोड करा",
      fullScreen: "पूर्ण स्क्रीन",
      mobileNote:
        "मोबाइलवर एम्बेडेड व्ह्यूअर छोटा दिसू शकतो — उत्तम अनुभवासाठी 'माहितीपत्रक डाउनलोड करा' वर टॅप करा.",
    },
    enquiryPage: {
      eyebrow: "चौकशी",
      title: "तुमच्यासाठी योग्य उपाय शोधूया.",
      subtitle: "तुमची गरज सांगा, आमची टीम लवकरच संपर्क करेल. लगेच बोलायचे आहे? व्हॉट्सअ‍ॅपवर त्वरित संपर्क करा.",
      sideEyebrow: "संपर्कात रहा",
      sideTitle: "तुम्हाला काय हवे ते सांगा.",
      sideText: "एक पंप असो वा संपूर्ण सिंचन प्रणाली, तुमच्या शेत, घर किंवा व्यवसायासाठी योग्य उपाय निवडण्यास आमची टीम तयार आहे.",
      chatWhatsapp: "व्हॉट्सअ‍ॅपवर संपर्क", fastest: "त्वरित प्रतिसाद",
      callUs: "आम्हाला कॉल करा", workingHours: "कामाचे तास",
      hoursValue: "सोम – शनि · सकाळी ९:०० ते रात्री ८:००",
    },
    contact: {
      eyebrow: "संपर्क",
      title: "आम्ही मदतीसाठी येथे आहोत.",
      subtitle: "उत्पादने, दर किंवा सहाय्यासाठी संपर्क साधा. आमची टीम नेहमीच तुमच्या मदतीस तत्पर आहे.",
      phone: "दूरध्वनी", email: "ईमेल", address: "पत्ता",
      messageWhatsapp: "व्हॉट्सअ‍ॅपवर संदेश पाठवा",
      followUs: "फॉलो करा",
    },
    form: {
      name: "नाव", company: "कंपनी", phone: "दूरध्वनी क्रमांक", email: "ईमेल",
      city: "शहर", state: "राज्य", product: "आवडलेले उत्पादन",
      requirement: "गरज", message: "संदेश",
      selectState: "राज्य निवडा", selectProduct: "उत्पादन निवडा",
      submit: "चौकशी पाठवा", submitting: "पाठवत आहे...",
      namePh: "तुमचे पूर्ण नाव", companyPh: "कंपनी / संस्था", phonePh: "+९१",
      emailPh: "you@example.com", cityPh: "शहर",
      reqPh: "उदा. संख्या, एचपी, आकार, कालावधी", msgPh: "तुमच्या गरजेविषयी अधिक सांगा...",
      validation: "कृपया तुमचे नाव व दूरध्वनी क्रमांक भरा.",
      successToast: "चौकशी यशस्वीरीत्या पाठवली!",
      errorToast: "काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा किंवा व्हॉट्सअ‍ॅप वापरा.",
      thankYou: "धन्यवाद!",
      thankYouText: "आमची टीम लवकरच तुमच्याशी संपर्क साधेल. त्वरित प्रतिसादासाठी व्हॉट्सअ‍ॅपवर संवाद सुरू ठेवा.",
      continueWhatsapp: "व्हॉट्सअ‍ॅपवर सुरू ठेवा",
      newEnquiry: "पुन्हा चौकशी करा",
    },
    marquee: ["पंप", "सिंचन", "पाईप", "केबल", "कृषी यंत्रसामग्री", "पाणी प्रणाली"],
    productExtra: {
      specifications: "तांत्रिक तपशील",
      availableSizes: "उपलब्ध आकार",
      advantages: "फायदे",
      model: "मॉडेल",
      downloadBrochure: "माहितीपत्रक डाउनलोड करा",
      productBrochure: "उत्पादन माहितीपत्रक",
      brochureCaption: "सर्व तांत्रिक तपशील व प्रकारांसह मूळ माहितीपत्रक.",
    },
  },
};
